import { render, staticRenderFns } from "./client-orders-calendar.vue?vue&type=template&id=e2fa5b94&"
import script from "./client-orders-calendar.vue?vue&type=script&lang=js&"
export * from "./client-orders-calendar.vue?vue&type=script&lang=js&"
import style0 from "./client-orders-calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports